module.exports = __webpack_public_path__ + "static/7-fb0c6482077abe53ed7e0a8743c97df5.jpeg";